export type ContactUs = {
    Name: string,
    Organization: string,
    Role: string,
    EmailAddress: string,
    Message: string,
};

export function newContactUs(): ContactUs {
    return {
        Name: "",
        Organization: "",
        Role: "",
        EmailAddress: "",
        Message: "",
    };
};